<template>
  <div
    :class="wrapperClass"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <img
      v-if="!hovered"
      :src="posterUrl"
      :class="className"
      :alt="alt"
      draggable="false"
      class="bg-gray-100 rounded w-full wrap-box"
    ></img>
    <video
      v-else
      ref="video"
      :src="videoUrl"
      :poster="posterUrl"
      :controls="controls"
      :class="className"
      autoplay
      muted
      playsinline
      class="bg-gray-100 rounded w-full wrap-box"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'HoverVideoImage',
  props: {
    videoUrl: { type: String, required: true },
    posterUrl: { type: String, required: true },
    controls: { type: Boolean, default: true },
    className: { type: [String, Array, Object], default: '' },
    alt: { type: String, default: '' },
    wrapperClass: { type: [String, Array, Object], default: '' },
  },
  data() {
    return { hovered: false };
  },
  methods: {
    onMouseEnter() {
      this.hovered = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.currentTime = 0;
          this.$refs.video.play();
        }
      });
    },
    onMouseLeave() {
      if (this.$refs.video) {
        this.$refs.video.pause();
        this.$refs.video.currentTime = 0;
      }
      this.hovered = false;
    },
  },
};
</script>
<style scoped lang="scss">
.wrap-box {
  min-height: 250px;
}
</style>
